import PropTypes from "prop-types";
import React, {Component} from "react";
import compose from "lodash/flowRight";
import {graphql} from "@apollo/client/react/hoc";
import {connect} from "react-redux";
import {withCaptcha} from "@unibuddy/captcha";
import requestPasswordResetMutation from "../../../Auth/mutations/requestPasswordResetMutation";
import {PasswordReset} from "../../../PasswordReset/components/PasswordReset/PasswordReset";

class RequestPasswordReset extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: false,
        };
    }

    async onRequestPasswordReset({email}, formActions) {
        this.setState({loading: true});
        const captureToken = await this.props.getCaptchaToken("requestPasswordReset");
        try {
            await this.props.requestPasswordReset({
                variables: {
                    email: email.toLowerCase(),
                    redirectUrl: this.props.redirectUrl,
                    rootUrl: this.props.rootUrl,
                    universitySlug: this.props.universitySlug,
                    localePreference: this.props.currentLocale,
                    captureToken,
                },
            });

            formActions.setSubmitting(false);
        } catch (e) {
            this.setState({loading: false, error: true});
            formActions.setSubmitting(false);
        }
    }

    render() {
        return (
            <PasswordReset
                loginLink={this.props.loginLink}
                themePrimary={this.props.themePrimary}
                onRequestPasswordReset={this.onRequestPasswordReset.bind(this)}
            />
        );
    }
}

RequestPasswordReset.propTypes = {
    themePrimary: PropTypes.string.isRequired,
    loginLink: PropTypes.string.isRequired,
    redirectUrl: PropTypes.string.isRequired,
    rootUrl: PropTypes.string.isRequired,
    universitySlug: PropTypes.string,
    currentLocale: PropTypes.string,
};

RequestPasswordReset.defaultProps = {
    redirectUrl: "",
    currentLocale: undefined,
};

const requestPasswordResetOptions = {
    name: "requestPasswordReset",
};

const mapStateToProps = () => ({});

export default compose(
    connect(mapStateToProps),
    graphql(requestPasswordResetMutation, requestPasswordResetOptions),
    withCaptcha,
)(RequestPasswordReset);
